// extracted by mini-css-extract-plugin
module.exports = {"wrap":"PostContentFile_wrap__nXSQ4","image":"PostContentFile_image__1xGqD","video":"PostContentFile_video__2E9rY"};